// @ts-nocheck
import React , {useEffect , useState} from 'react';
import DOMPurify from 'dompurify';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import localStorageManagement from '../Security/LocalStorageManagement';
import SinapTheme from "../styles/SinapTheme";
import makeStyles from '@mui/styles/makeStyles';
import { useBody } from './state/BodyContext';

const useStyles = makeStyles((theme) => ({
    root: {
        '&:hover': {
            transform:
                `scale(1.01,1.01)`,
            transition: `transform 150ms`
        }
    }}));

export default function AccordionItem({info , onClick}) {

  const classes = useStyles();
  const [color , setColor] = useState('#000000');
  const [expanded, setExpanded] = useState(false);
  const { noticesNotViews } = useBody();

  const updateView = () => {
    const viewsNotices = localStorageManagement.getViewsNotices();
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    updateView();
  },[noticesNotViews])

  return (
      <div className={classes.root}>
      <Accordion onClick={() => onClick(info.noticia)} onMouseOver={() => handleChange(info.titulo)} onMouseLeave={() => {
          // when container is leaved either close all
          // or you can call the function with the default opened pannel
          handleChange("");
      }}
        expanded={expanded === info.titulo} onChange={handleChange(info.titulo)}
      >
        <AccordionSummary
          sx={{
            backgroundColor: {color}
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{info.titulo}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(info.contenido)}}></p>
        </AccordionDetails>
      </Accordion>
      </div>
  );
}